import { Component } from '@angular/core';
import { FieldType } from '@ngx-formly/core';

@Component({
  selector: 'xilo-mono-form-viewer-text',
  templateUrl: './text.component.html',
  styleUrls: ['../../form-viewer.component.scss', './text.component.scss'],
})
export class CustomTextComponent extends FieldType {
  isInvalid = false;
  errorMessage = false;

  styleText() {
    const styleObj = {};
    const styleParams = ['fontSize', 'fontWeight', 'color', 'textAlign'];
    for (const key of styleParams) {
      if (this.to[key]) {
        styleObj[key] = this.to[key];
      }
    }
    if (this.to.borderBottom && this.to.link) {
      styleObj['border-bottom'] = this.to.borderBottom;
    }
    return styleObj;
  }

  hasLink(link: string) {
    return link && link !== '';
  }

  getError() {
    return 'Invalid response';
  }
}
